// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import BreadcrumbsPresentationPropsDefault from "@insite/mobius/Breadcrumbs/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { xBaseTheme } from "@steiner/XDL/types";
import { color, hideElementOnPrint } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...BreadcrumbsPresentationPropsDefault,
        mergeCss: true,
        linkProps: {
            color: "text.main",
            typographyProps: {
                size: 14,
                weight: "normal",
                css: css`
                    letter-spacing: 0;
                    line-height: 22px;
                    max-width: 100%;
                    word-wrap: break-word;
                `,
            },
            css: css`
                &:focus {
                    outline: none;
                }
                &:hover > ${TypographyStyle} {
                    color: ${color("text.link")};
                }
            `,
        },
        typographyProps: {
            size: 14,
            weight: "bold",
            css: css`
                letter-spacing: 0;
                line-height: 22px;
                max-width: 100%;
                word-wrap: break-word;
            `,
        },
        css: css`
            flex-wrap: wrap;
            gap: 8px;

            ${hideElementOnPrint}
        `,
    },
} as xBaseTheme["breadcrumbs"];
